import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SensitiveStep_1Page } from './sensitive-step-1';
import {ComponentsModule} from "../../../components/components.module";

@NgModule({
  declarations: [
    SensitiveStep_1Page,
  ],
  imports: [
    IonicPageModule.forChild(SensitiveStep_1Page),
    ComponentsModule
  ],
})
export class SensitiveStep_1PageModule {}



// WEBPACK FOOTER //
// ./src/pages/sensitive/sensitive-step-1/sensitive-step-1.module.ts